document.addEventListener("DOMContentLoaded", () => {
	const reScrollToHash = () => {
		if (!location.hash) return;
		const id = location.hash.slice(1);
		if (!id) return;

		const escapeId = window.CSS && CSS.escape ? CSS.escape(id) : id.replace(/["\\]/g, "\\$&");
		const target =
			document.getElementById(id) ||
			document.querySelector(`[name="${escapeId}"]`);
		if (!target) return;

		const header = document.querySelector(".header");
		const offset = header ? header.offsetHeight + 12 : 0;
		const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
		window.scrollTo({ top, behavior: "auto" });
	};

	// Re-run after layout settles and on hash changes.
	window.addEventListener("load", () => setTimeout(reScrollToHash, 0));
	window.addEventListener("hashchange", () => setTimeout(reScrollToHash, 0));
});
